import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { Uploader } from 'ui/components';

const initialState = {
  note: '',
  attachments: [],
  isPdfopen: false,
  showFile: false,
  file: null,
};

export const FormNote = ({
  data,
  onChange,
  isLoading
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    {
      note,
      attachments,
      showFile,
      isPdfopen,
      file
    },
    setState,
  ] = React.useState(initialState);

  const $closeModal = async() =>  {
    setState((prevState) => ({...prevState, showFile: false, isPdfopen: false, file: null}));
  }

  const $removeField = async(i) => {
    let newAttachments = [...attachments];
    newAttachments.splice(i, 1);

    setState((prevState) => ({...prevState, attachments: newAttachments }));
  }

  const $postImage = async(e) => {
    setState((prevState) => ({...prevState, attachments: [...attachments, ...e]}));
  }

  React.useEffect(() => {
    const state = {
      note,
      attachments,
    };

    onChange(state);
  }, [
    note,
    attachments
  ]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      note: data?.note,
      attachments: data?.attachments || [],
    }));
  }, [data]);

  return (
    <div className='mt-1'>
      {isLoading ? (
        <SkeletonsForm count={2} />
      ) : (
        <div className='py-2'>
          <Form.Textbox
            label="Catatan"
            type="text"
            value={note}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                note: e.target.value,
              }))
            }
            error={StateForm?.errors?.note}
          />

          <div className='mb-3'>
            <div className="py-2 fs-7 fw-semibold">Lampiran</div>
            {attachments?.map((e, i) => (
              <div className='row mb-2'>
                <div className='col-3'>
                  <p
                    className='text-decoration-underline text-primary'
                    key={i}
                    onClick={() => {
                      e?.includes('.pdf')
                      ? setState((prevState) => ({
                        ...prevState,
                        isPdfopen: true,
                        file: e,
                      }))
                      : e?.includes('.xlsx')
                      ? window.open(e, '_blank')
                      : setState((prevState) => ({
                        ...prevState,
                        showFile: true,
                        file: e,
                      }));
                    }}
                  >
                    Lampiran {i+1}
                  </p>
                </div>
                <div className='col-2'>
                  <button
                    type="button"
                    className="btn btn-transparant rounded"
                    onClick={() => $removeField(i)}
                  >
                    <Fi.FiMinusCircle  />
                  </button>
                </div>
              </div>
            ))}

            <Uploader
              medium
              setData={(e) => $postImage(e)}
            />
          </div>
        </div>
      )}

      <Modal
        show={showFile}
        onHide={() => $closeModal()}
        backdrop="static"
        centered
        size="lg"
        enforceFocus={true}
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={() => $closeModal()}
          />
          <div className="text-center mt-4" style={{ maxHeight: 500 }}>
            <img
              src={file?.replace('_thumb', '')}
              alt=""
              className="img-fluid"
              style={{ maxHeight: 500 }}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* pdf open */}
      <Modal
        show={isPdfopen}
        onHide={() => $closeModal()}
        className="text-center bg-transparent"
        contentClassName="bg-transparent "
        centered
        size="xl"
      >
        <Modal.Body className="bg-transparent" style={{ height: '95vh' }}>
          <div
            className="btn-close"
            onHide={() => $closeModal()}
          />

          <iframe
            title=" "
            src={file}
            style={{
              width: '100%',
              height: '100%',
            }}
            frameBorder="0"
          ></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
};
